import { ObjectDirective } from 'vue'

// 自定义指令，用于处理点击外部区域的事件
const clickOutside: ObjectDirective = {
  beforeMount(el, binding) {
    console.log('beforeMount clickOutside')
    // 在元素上绑定一个事件监听器
    el.clickOutsideEvent = function (event: any) {
      // 判断点击事件是否发生在元素外部
      if (!(el === event.target || el.contains(event.target))) {
        console.log('clickOutsideEvent', el, event.target, el === event.target, el.contains(event.target))
        // 如果是外部点击，则执行绑定的函数
        binding.value(event)
      }
    }
    // 在全局添加鼠标按下事件监听器【点击事件在teleport弹窗出现后无效】
    document.addEventListener('mousedown', el.clickOutsideEvent)
  },
  // updated(el, binding) {
  //   console.log('updated', el.clickOutsideEvent)
  //   // unmounted(el)
  //   document.removeEventListener('click', el.clickOutsideEvent)
  //   document.addEventListener('click', el.clickOutsideEvent)
  // },
  unmounted(el) {
    console.log('unmounted clickOutside')
    // 在组件销毁前，移除事件监听器以避免内存泄漏
    document.removeEventListener('mousedown', el.clickOutsideEvent)
  }
}

export default clickOutside
